const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    sui: state => state.user.sui,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    userName: state => state.user.userName,
    roles: state => state.user.roles,
    getToolData:state =>state.toolBarData,
    getCacheView:state =>state.cacheView,
}
export default getters